import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-product-use-mantainance',
  templateUrl: './custom-product-use-mantainance.component.html',
  styleUrls: ['./custom-product-use-mantainance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomProductUseMantainanceComponent implements OnInit {
  product$: Observable<Product>;
  private contentPlaceholder: ElementRef;

  @ViewChild('hideParentComponent') set content(content: ElementRef) {
    if (content) {
      this.contentPlaceholder = content;
      const hideTab = this.contentPlaceholder?.nativeElement?.parentNode?.parentNode?.parentNode;
      if (hideTab) {
        hideTab.style.display = 'none';
      }
    }
  }

  constructor(protected currentProductService: CurrentProductService) {
  }

  ngOnInit(): void {
    this.product$ = this.currentProductService.getProduct();
  }
}
